<template>
    <div id="configuratore" sf-versione="2.0" sf-component="configuratore" class="veu-cart sf-stripe" sf-cart-id="link"
        :sf-cart-option="offerta.option" :sf-cart-utility="offerta.utility" :sf-cart-pagamento="offerta.pagamento" :sf-cart-bolletta="offerta.bolletta">

        <cover class="bottom-striped" :class="elemClass[0]" @onNext="next" />
        <Residenza class="bottom-striped" :class="elemClass[1]" @onNext="next" @onBack="prev" />
        <Consumption class="bottom-striped" :class="elemClass[2]" @onNext="next" @onBack="prev" />
        <Payment class="bottom-striped" :class="elemClass[3]" @onNext="next" @onBack="prev" />
        <Prices class="bottom-striped" :class="elemClass[4]" @onBack="prev" 
            :commodity="params.commodity" :mono="params.mono" :gas="params.gas" :light="params.light" 
            :resident="params.resident" :zip="params.zip"
            :digital="params.digital" :bollettino="params.bollettino" />

        <ul class="sf2-slick-dots" v-if="elemClass[0]!='current'">
            <li :class="{ 'slick-active': elemClass[1] == 'current' }"></li>
            <li :class="{ 'slick-active': elemClass[2] == 'current' }"></li>
            <li :class="{ 'slick-active': elemClass[3] == 'current' }"></li>
            <li :class="{ 'slick-active': elemClass[4] == 'current' }"></li>
        </ul>
    </div>
</template>

<script>
    import Cover from './pages/Cover.vue';
    import Residenza from './pages/Residenza.vue';
    import Consumption from './pages/Consumption.vue';
    import Payment from './pages/Payment.vue';
    import Prices from './pages/Prices.vue';

export default {
    name: "Configuratore",
    components: {
        Cover, // Card,
        Residenza, // Card,
        Consumption, // Card,
        Payment, // Card,
        Prices // Card,
    },
    props: {
    },
    data() {
        return {
            loaded: true,
            current: 0,
            elemClass: [
                'current', 'next-0', 'next-1', 'next-2', 'next-3'
            ],
            params: {
                'mono': true,
                'commodity': 'dual',
                'digital': true,
                'bollettino': false,
                'resident': true,
                'zip': "0",
                'gas': 0,
                'light': 0,
            },
            offerta: {
                'option': '',
                'utility': '',
                'pagamento': '',
                'bolletta': '',
            }
        }
    },
    created: function () {
        
    },
    mounted() {
        // this.loaded = true;
    },
    computed: {
    },
    methods: {
        next( event ) {
            console.log( 'Preventivatore next', event );

            for (const key in event) {
                this.params[key] = event[key];
                console.log(`Preventivatore next params-> ${key}: ${event[key]}`);
            }
            console.log('Preventivatore next params', this.params);

            this.offerta.option = ( this.params.mono == true ) ? 'Monoraria' : 'Bioraria';
            this.offerta.utility = ( this.params.commodity == 'dual' ) ? 'LUCE E GAS' : ( this.params.commodity == 'gas' ) ? 'GAS' : 'LUCE';
            this.offerta.bolletta = ( this.params.digital == true ) ? 'Digitale' : 'Cartacea';
            this.offerta.pagamento = ( this.params.bollettino == true ) ? 'Bollettino' : 'Addebito C/C';

            //- ---
            //- calculate Card visibility ---

            this.current++;

            for (let i = 0; i < this.elemClass.length; i++) {
                if ( this.current - i > 0 ){
                    this.elemClass[i] = 'prev';
                }
                if ( this.current - i == 0 ){
                    this.elemClass[i] = 'current';
                }
                if ( this.current - i < 0 ){
                    this.elemClass[i] = 'next-'+( - this.current + i - 1 );
                }
            }
            
            this.$forceUpdate();
            console.log( 'Preventivatore next recap', this.elemClass, this.current, this.elemClass.length - 1 );
        },

        prev( event ) {
            console.log( 'Preventivatore prev', event );

            //- ---
            //- calculate Card visibility ---

            this.current -= event;

            for (let i = 0; i < this.elemClass.length; i++) {
                if ( this.current - i > 0 ){
                    this.elemClass[i] = 'prev';
                }
                if ( this.current - i == 0 ){
                    this.elemClass[i] = 'current';
                }
                if ( this.current - i < 0 ){
                    this.elemClass[i] = 'next-'+( - this.current + i - 1 );
                }
            }
            
            this.$forceUpdate();
            console.log( 'Preventivatore next recap', this.elemClass, this.current, this.elemClass.length - 1 );
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

    body.configuratore { background: #f5f5f5; color: #333; margin: 0; padding: 0;
        font-family: Avenir, Helvetica, Arial, sans-serif; padding: 60px;

        * { box-sizing: border-box; }
    }
    
    [sf-versione="2.0"][sf-component="configuratore"] {
        font-size: 14px;
        
        .lock-down {position: absolute; left: 30px; right: 30px; bottom: 30px;
            button:last-child {margin-top: 0;}
        }

        input[type="text"] { width: 100%; height: 48px; border: 1px solid #aaa; border-radius: 10px; padding: 0 15px; line-height: 48px; font-size: 16px;
            margin-top: 15px; display: block; background: transparent; outline:none
        }
        input[type="text"].unit { width: calc(100% - 50px); display: inline-block; margin-right: 10px; }
        input[type="text"]::placeholder {font-size: 14px;}

        .sf2__title--left-stroke, .title--left-stroke {
            line-height: 1.4em;
        }

        .question-label {font-weight: bold; margin-top: 30px;}

        .switchRow { 
            .question-label {margin-top: 0;}
        }

        .form-label {font-weight: bold; margin-top: 30px; margin-bottom: 0;}

        .form-row {position: relative; font-size: 14px;}

        .header {
            .back { float: left; text-align: center; padding-top: 8px;
                .icon-dropdown_up {transform: rotate(-90deg); font-size: 16px; display: block; margin-bottom: 5px;}
            }
            .sf2__title--left-stroke { margin-left:60px; }
        }
    }

</style>

<style lang="scss" scoped>

    [sf-versione="2.0"][sf-component="configuratore"] { 
        width: 360px; position: relative; z-index: 10;

        .sf2-slick-dots { top:590px; position: absolute; left: 50%; transform: translateX(-50%); display: none;}

        @media (max-width: 1023px) {
            width: 330px; padding-bottom: 60px;
            .sf2-slick-dots {display: block;}
        }
        @media (max-width: 1023px) {
            margin: 0 auto;
        }
        @media (min-width: 1024px) {
            padding: 0; margin: 0; position: absolute; right: 15px; top: 20px;
        }
        @media (min-width: 1200px) {
            right: 50%; margin-right: -583px;
        }

        > .bottom-striped {
            background: #fff; height: 540px; width: 360px; position: absolute; top: 0; left: 0; 
            border-radius: 10px; padding:30px; z-index: 10; transition: all 0.3s; display: block;

            @media (max-width: 1023px) {
                width: 330px;
                &.current { position: relative; }
            }

            &::before {
                content: '';
                background-color: #fff;
                border-radius: 10px;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                z-index: -1;
            }

            &::after {
                z-index: -5;
            }

            &.prev {
                transform: translateX(-100%); opacity: 0;
            }

            &.next-0,
            &.next-1,
            &.next-2,
            &.next-3,
            &.next-4 {
                z-index: 5;
                filter: grayscale(100%);
                opacity: 0;
            }
        
            @media (min-width: 1024px) {
                &.next-0 {
                    transform: scale(0.9); z-index: 9;
                    left: 30px; filter: grayscale(100%);
                    opacity: 0.8;
                }

                &.next-1 {
                    transform: scale(0.8); z-index: 8;
                    left: 60px; filter: grayscale(100%);
                    opacity: 0.6;
                }

                &.next-2 {
                    transform: scale(0.7); z-index: 7;
                    left: 90px; filter: grayscale(100%);
                    opacity: 0.4;
                }

                &.next-3 {
                    transform: scale(0.6); z-index: 6;
                    left: 120px; filter: grayscale(100%);
                    opacity: 0.2;
                }

                &.next-4 {
                    transform: scale(0.4); z-index: 5;
                    left: 120px; filter: grayscale(100%);
                    opacity: 0;
                }
            }
        }
    }
    
</style>